import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import { useState , useEffect} from "react";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import {loginApi} from '../../services/auth.js'
import {setAuthData} from '../../util/common.js'
import { URL } from "../../api";


const Login = () => {

 
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [modalOpen, setModalOpen] = useState(false);

  const [rememberMe, setRememberMe] = useState(false);

const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
   
  useEffect(() => {
  const checkAuthCookie = () => {
    const token = document.cookie
      .split('; ')
      .find(row => row.startsWith('auth_token='))
      ?.split('=')[1];

    const isLoggingOut = sessionStorage.getItem('logout');

    if (token && !isLoggingOut) {
      navigate('/admin/lead-list');
    }

    // Clear logout flag after checking
    sessionStorage.removeItem('logout');
  };

  checkAuthCookie();
}, [navigate]);


  const handleLogin = async () => {
    const loginData = {
      url : URL.LOGIN,
      post_data: {
        user_name: formData.username,
        password: formData.password
      }
    };
    try {
      

      loginApi(loginData).then(response => {
        console.log("response")
        console.log(response)
        if (response.response && response.response.status === 200) {
          console.log(response.data)
          console.log(response.data.token)
          if (response.data.privilege === null) response.data.privilege = '{}';


          setAuthData(response.data);

          if (rememberMe) {
            const now = new Date();
            now.setTime(now.getTime() + 24 * 60 * 60 * 1000); // 24 hours
            document.cookie = `auth_token=${response.data.token}; expires=${now.toUTCString()}; path=/`;
          }else {
            // Clear the cookie if not remembering
            document.cookie = "auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          }


         navigate('/admin/lead-list');

       


        }else{
          console.error("Error Login...");
          
          let msg = "Error Login!";
          if (response.response){
            msg += "Status Code "+response.response.status
          }

          
          toast.error(msg, {
            autoClose: 4000,
            position: "bottom-center",
          });
         }
      }).catch(error => {
  console.error("Login error:", error);

  const errorMessage = error?.response?.data?.error || "Invalid username or password";

  toast.error(errorMessage, {
    autoClose: 4000,
    position: "bottom-center",
  });
});

    } catch (error) {
      console.error("Error during login: ", error);
  
      toast.error("Error during login: "+ error.message , {
        autoClose: 4000,
        position: "bottom-center",
      });
    }

   
  };


  const pillInput = {
    borderRadius: 999,
    background: "#f5f6f8",
    border: "1px solid #e6e8ec",
    padding: "1.35rem 1.25rem",
  };

  return (
    <div style={{ width: "100%" }}>
      <h2 style={{ fontWeight: 800, fontSize: "2rem", marginBottom: 6, color: "#111827" }}>
        Welcome back!
      </h2>
      <p className="text-muted" style={{ marginBottom: "1.75rem" }}>
        Sign in to the Salora Capital LMS portal.
      </p>

      <Form role="form" onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
        <FormGroup className="mb-3">
          <Input
            placeholder="Username"
            type="text"
            autoComplete="new-email"
            name="username"
            value={formData.username}
            onChange={handleChange}
            style={pillInput}
          />
        </FormGroup>

        <FormGroup className="mb-2">
          <InputGroup style={{ ...pillInput, padding: 0, overflow: "hidden" }}>
            <Input
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              autoComplete="new-password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              style={{ border: "none", background: "transparent", padding: "1.35rem 1.25rem" }}
            />
            <InputGroupAddon addonType="append">
              <InputGroupText
                style={{ cursor: "pointer", border: "none", background: "transparent" }}
                onClick={() => setShowPassword(!showPassword)}
              >
                <i className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"} />
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>
        </FormGroup>

        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="custom-control custom-control-alternative custom-checkbox text-nowrap mr-3" style={{ flexShrink: 0 }}>
            <input
              className="custom-control-input"
              id="customCheckLogin"
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <label className="custom-control-label text-nowrap" htmlFor="customCheckLogin">
              <span className="text-muted"><small>Remember me</small></span>
            </label>
          </div>
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); setModalOpen(true); }}
            style={{ color: "#111827", fontWeight: 500 }}
          >
            <small>Forgot Password?</small>
          </a>
        </div>

        <Button
          type="submit"
          style={{
            width: "100%",
            borderRadius: 999,
            background: "#0b1f38",
            border: "none",
            padding: "0.9rem",
            fontWeight: 600,
            color: "#fff",
          }}
        >
          Login
        </Button>
      </Form>

      {/* Forgot Password Modal */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} centered size="sm">
        <ModalHeader toggle={() => setModalOpen(false)}>Forgot Password</ModalHeader>
        <ModalBody>
          <strong>Please contact the Admin.</strong>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalOpen(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Login;
